import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import useCustomTooltip from "./useCustomInfoTooltip";

const CustomInfoTooltip = ({ message }) => {
  const { open, handleTooltipClose, handleTooltipOpen } = useCustomTooltip();

  return (
    <Tooltip
      onClose={handleTooltipClose}
      open={open}
      title={message}
      onClick={handleTooltipOpen}
      onMouseEnter={handleTooltipOpen}
      onMouseLeave={handleTooltipClose}
    >
      <IconButton aria-label="info" size="small">
        <InfoIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
};

export default CustomInfoTooltip;
